<template>
  <div>
    <div class="d-flex align-items-center mb-2 w-100">
      <h1>Preços e Condições</h1>
      <div class="ml-auto">
        <b-button
          size="sm"
          variant="exitos"
          :disabled="!isAllowAddPeriodicities"
          @click="openModal()"
        >
          Adicionar Ciclo
        </b-button>
      </div>
    </div>
    <b-card>
      <b-table
        striped
        hover
        :items="list"
        :fields="fields"
        :busy="isBusy"
        :tbody-tr-class="rowClass"
        show-empty
      >
        <template #cell(status)="{ value, item }">
          <label class="mb-0">
            <b-form-checkbox
              switch
              inline
              button-variant="secondary"
              :checked="item.status"
              class="switch-status cursor-pointer d-flex flex-row mr-0"
              @change="changeStatus($event, item)"
            />
          </label>
        </template>
        <template #cell(periodicidade)="{ value, item }">
          <div v-if="item?.is_default">
            <div class="d-inline-flex">
              <h5 class="font-weight-normal mb-0 mr-2" v-text="value" />
              <div
                class="d-inline-flex align-items-center badge badge-success badge-pill"
              >
                <font-awesome-icon icon="check" class="mr-1" />
                Ciclo padrão
              </div>
            </div>
          </div>
          <h5 v-else class="font-weight-normal mb-0 mr-2" v-text="value" />
        </template>
        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            @edit="handleEdit"
            @delete="handleDelete"
          />
        </template>

        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontrado</h5>
        </template>

        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </b-card>

    <b-modal
      id="modal-periodicidade-plano"
      ref="modal-periodicidade-plano"
      size="lg"
      centered
      ok-title="Salvar"
      cancel-title="Cancelar"
      ok-variant="exitos"
      :title="modalTitle"
      :ok-disabled="isBusy"
      @ok="handleSave"
      @hidden="resetModal"
    >
      <FormPeriodicidade
        ref="form-periodicidade"
        v-model="selectedItem"
        :active-periodicities="activePeriodicities"
      />
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import safeArray from "lodash/toArray";
import Actions from "@/components/Table/Actions.vue";
import cloneDeep from "lodash/cloneDeep";

import FormPeriodicidade from "./FormPeriodicidade.vue";
import { getEmptyPeriodicidade } from "@/modules/planos/Components/Form/getEmptyPeriodicidade";
import { getPeriodicidades } from "@/modules/planos/Components/Form/getPeriodicidades";

export default {
  components: { Actions, FormPeriodicidade },
  data: () => ({
    list: [],
    isBusy: false,
    selectedItem: null,
  }),
  validations: {},
  computed: {
    ...mapState("planos", ["plano"]),
    modalTitle() {
      return this.selectedItem?.id ? "Editar ciclo" : "Novo ciclo";
    },
    fields() {
      return [
        {
          key: "status",
          label: "Ativo",
          class: "col-1 text-center align-middle title-status",
        },
        { key: "periodicidade", label: "Ciclo", class: "col-5" },
        {
          key: "valor_base",
          label: "Valor",
          class: "col-auto",
          formatter: (value) => this.formatCurrency(value),
        },
        {
          key: "desc_boleto",
          label: "Boleto",
          class: "col-auto",
          formatter: (value) => this.formatPercent(value),
        },
        {
          key: "desc_pix",
          label: "Pix",
          class: "col-auto",
          formatter: (value) => this.formatPercent(value),
        },
        {
          key: "parcelas_credito",
          label: "Crédito",
          class: "col-auto text-center",
          formatter: (value) => (value ? `${value}x` : ""),
        },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
    activePeriodicities() {
      return safeArray(this.list).map((item) => item.periodicidade);
    },
    isAllowAddPeriodicities() {
      const activePeriodicities = this.activePeriodicities;
      const availablePeriodicities = getPeriodicidades().filter(
        ({ value }) => value && !activePeriodicities.includes(value)
      );

      return availablePeriodicities.length > 0;
    },
  },
  methods: {
    ...mapActions("planos", [
      "ActionGetPeriodic",
      "ActionSavePeriodic",
      "ActionDeletePeriodic",
    ]),
    formatCurrency(value) {
      if (typeof value !== "number") return value || "";
      return `R$ ${this.$options.filters.number_format(value, "0,000.00")}`;
    },
    formatPercent(value) {
      if (value === null || value === undefined || value === "") return "";
      return `${this.$options.filters.number_format(value, "0,000.00")}%`;
    },
    handleEdit(item) {
      this.openModal(item);
    },
    async handleDelete(item) {
      if (!item?.id) return;

      try {
        await this.ActionDeletePeriodic(item.id);
        this.$notifications.addNotification({
          message: "Ciclo removido com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao remover ciclo",
          type: "danger",
        });
      }
    },
    openModal(item = null) {
      if (!item && !this.isAllowAddPeriodicities) return;

      this.selectedItem = item ? cloneDeep(item) : getEmptyPeriodicidade();
      this.$bvModal.show("modal-periodicidade-plano");
    },
    async changeStatus(isChecked, data = {}) {
      const payload = cloneDeep(data);
      payload.status = isChecked;

      try {
        this.isBusy = true;
        await this.ActionSavePeriodic(payload);
        await this.loadData();

        this.$notifications.addNotification({
          message: "Status do ciclo atualizado com sucesso!",
          type: "success",
        });
      } catch (_error) {
        this.$notifications.addNotification({
          message: "Erro ao tentar atualizar status",
          type: "danger",
        });
      } finally {
        this.isBusy = false;
      }
    },
    async handleSave(event) {
      event.preventDefault();

      const form = this.$refs["form-periodicidade"];
      const payload = form?.save();

      if (!payload) return;

      payload.plano_exitos_id = this.$route?.params?.id;
      this.isBusy = true;

      try {
        await this.ActionSavePeriodic(payload);
        this.$notifications.addNotification({
          message: "Ciclo salvo com sucesso",
          type: "success",
        });

        await this.loadData();
        this.$nextTick(() => {
          this.$bvModal.hide("modal-periodicidade-plano");
        });
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao salvar ciclo",
          type: "danger",
        });
      } finally {
        this.isBusy = false;
      }
    },
    resetModal() {
      this.selectedItem = null;
      this.$refs["form-periodicidade"]?.reset();
    },
    isRowInactive(item) {
      return !!item?.status;
    },
    rowClass(item, type) {
      if (!item || type !== "row") return "";
      return this.isRowInactive(item) ? "" : "row-disabled";
    },
    isValid() {
      return true;
    },
    reset() {},
    async loadData() {
      if (!this.$route?.params?.id) return;

      this.isBusy = true;
      try {
        const params = {
          plano_exitos_id: this.$route.params.id,
          per_page: 10,
        };

        const response = await this.ActionGetPeriodic(params);
        this.list = safeArray(response.data);
      } finally {
        this.isBusy = false;
      }
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
::v-deep .row-disabled {
  [role="cell"]:not(.cell-actions):not(.title-status) {
    opacity: 0.5;
  }
}

::v-deep .switch-status {
  min-width: fit-content;

  .custom-control-label {
    &::before,
    &::after {
      cursor: pointer;
    }
  }
}
</style>
